import React from "react";
import css from "./FieldHeader.module.css";
import TypeText from "../../../TypeText/TypeText";
import {Badge} from "Components";
import {chevron0} from "Assets";


export default function FieldHeader(props){
    const {field,openable,open}=props,{name,type,required,deprecated}=field;
    const typename=typeof(type)==="string"?type:type?.name;
    return (
        <header 
            className={`${css.fieldheader} ${props.className||""}`} 
            openable={openable&&""}
        >
            {openable&&<img 
                className={css.icon} alt=">"
                src={chevron0(textColor,2)}
                style={{transform:`rotateZ(${open?270:180}deg)`}}
            />}
            <span 
                className={css.name} 
                style={{textDecoration:deprecated?"line-through":null}}
            >{name}</span>
            {required&&<Badge className={css.requiredbadge} text="required"/>}
            {typename&&
                <TypeText
                    style={{color:[":","|"].some(char=>typename.includes(char))?minorColor:mainColor}}
                    type={type||"any"}
                />
            }
            {"defaultValue" in field&&<Badge 
                className={css.defaultvaluebadge}
                text={String(field.defaultValue)}
            />}
        </header>
    )
}
